import { useAppSelector } from '@/hooks/useAppSelector';

import { selectTagsOptions } from '../services/selectors';

export const useTagsOptions = () => useAppSelector(selectTagsOptions);
